import { LoadingButton } from "@mui/lab";
import type { TooltipProps } from "@mui/material";
import { Button, styled, Tooltip, tooltipClasses } from "@mui/material";
import type { ReactNode } from "react";
import { memo } from "react";

export interface ButtonBaseProps {
    variant: "text" | "outlined" | "contained" | undefined;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    startIcon?: ReactNode;
    children: string | ReactNode;
    styles?: any;
    type?: any;
    disabled?: boolean;
    cursor?: "pointer" | "not-allowed";
    tooltip?: string;
    loading?: boolean;
    id?: string;
}

const TooltipDark = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} placement="top" arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

const ButtonBase = (props: ButtonBaseProps) => {
    const {
        children,
        variant,
        onClick,
        startIcon,
        styles,
        type,
        disabled,
        cursor,
        tooltip,
        loading = false,
        id,
    } = props;

    const options = {
        type: type || undefined,
        style: {
            width: "100%",
            color: variant !== "contained" && "black",
            backgroundColor: variant === "contained" ? (disabled == true ? "#dadada" : "#141516") : "#fff",
            border: variant !== "contained" && "1px solid black",
            borderRadius: "2px",
            boxShadow: "none",
            textTransform: "none",
            cursor,
            fontFamily: "Poppins",
            fontWeight: "400",
            ...styles,
        },
        variant,
        onClick,
        startIcon,
        disabled,
        id,
    };

    return (
        <TooltipDark title={tooltip ?? ""}>
            {(loading && (
                <LoadingButton loading {...options} style={{ backgroundColor: "#dadada" }} disabled>
                    {children}
                </LoadingButton>
            )) || (
                <span>
                    <Button {...options}>{children}</Button>
                </span>
            )}
        </TooltipDark>
    );
};

export default memo(ButtonBase);
